import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Globe, Tag, Sun, Calendar, Flag, Plane, MapPin, Compass, Star, Umbrella } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TravelCard from '../components/TravelCard';
// [NocheYDia previa] import AdvertisingBanner from '../components/AdvertisingBanner';
// [NocheYDia previa] import SoldSection from '../components/SoldSection';
// [NocheYDia previa] import AirlinesSection from '../components/AirlinesSection';
// [NocheYDia previa] import BestPriceSection from '../components/BestPriceSection';
// [NocheYDia previa] import EuropeSection from '../components/EuropeSection';
// [NocheYDia previa] import InspirationSection from '../components/InspirationSection';
// [NocheYDia previa] import NewsletterSection from '../components/NewsletterSection';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://opcionesargentinas.com';

const flyerUrl = (archivo) => `${process.env.REACT_APP_API_URL}/flyers/imagen/${archivo}`;

// Imágenes de ejemplo que se muestran mientras el admin no cargue flyers propios
const FLYERS_TEMPORALES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => ({ id: `tmp-${n}`, url: `/images/IMG${n}.jpeg` }));

// Cada cuánto rota automáticamente el filtro de región de los flyers
const ROTACION_FLYERS_MS = 8000;

const DESTINOS_LOGOS = [
  { nombre: 'Brasil',        logo: '/images/LOGOS OPCIONES/01_Opciones_en_Brasil.png' },
  { nombre: 'Caribe',        logo: '/images/LOGOS OPCIONES/02_Opciones_en_Caribe.png' },
  { nombre: 'Europa',        logo: '/images/LOGOS OPCIONES/03_Opciones_en_Europa.png' },
  { nombre: 'Perú',          logo: '/images/LOGOS OPCIONES/04_Opciones_en_Perú.png' },
  { nombre: 'Medio Oriente', logo: '/images/LOGOS OPCIONES/05_Opciones_en_Medio_Oriente.png' },
];

function ScrollCarousel({ children }) {
  const ref = useRef(null);

  const scroll = (dir) => {
    if (!ref.current) return;
    const card = ref.current.querySelector('[data-card]');
    const cardWidth = card ? card.offsetWidth + 16 : 320;
    ref.current.scrollBy({ left: dir * cardWidth, behavior: 'smooth' });
  };

  return (
    <div className="relative group">
      <button
        onClick={() => scroll(-1)}
        className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-9 h-9 rounded-full bg-black/70 shadow-lg flex items-center justify-center text-white text-xl hover:bg-black transition-all opacity-0 group-hover:opacity-100"
        aria-label="Anterior"
      >
        ‹
      </button>
      <div
        ref={ref}
        className="flex gap-4 overflow-x-auto pb-3"
        style={{ scrollSnapType: 'x mandatory', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {children}
      </div>
      <button
        onClick={() => scroll(1)}
        className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-9 h-9 rounded-full bg-black/70 shadow-lg flex items-center justify-center text-white text-xl hover:bg-black transition-all opacity-0 group-hover:opacity-100"
        aria-label="Siguiente"
      >
        ›
      </button>
    </div>
  );
}

// Popup de flyer en grande con botones para descargar e imprimir
function FlyerModal({ flyer, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const descargar = async () => {
    try {
      const response = await fetch(flyer.url);
      const blob = await response.blob();
      const objUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objUrl;
      a.download = flyer.url.split('/').pop() || 'flyer.jpg';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(objUrl), 5000);
    } catch (error) {
      window.open(flyer.url, '_blank');
    }
  };

  const imprimir = () => {
    const w = window.open('', '_blank');
    if (!w) return;
    w.document.write(
      `<!doctype html><html><head><title>Flyer</title>` +
      `<style>@page{margin:0}body{margin:0;display:flex;align-items:center;justify-content:center;min-height:100vh}img{max-width:100%;max-height:100vh}</style>` +
      `</head><body><img src="${flyer.url}" onload="setTimeout(function(){window.print()},200)"></body></html>`
    );
    w.document.close();
  };

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="relative max-w-3xl w-full max-h-full flex flex-col items-center"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 z-10 w-10 h-10 rounded-full bg-white text-gray-800 text-xl font-bold shadow-lg hover:bg-gray-200 transition-colors"
          aria-label="Cerrar"
        >
          ✕
        </button>
        <img
          src={flyer.url}
          alt="Flyer"
          className="max-w-full max-h-[75vh] rounded-xl shadow-2xl object-contain"
        />
        <div className="flex gap-3 mt-4">
          <button
            onClick={descargar}
            className="bg-[#2AA8B0] hover:bg-[#1E8A91] text-white font-bold px-6 py-3 rounded-full transition-all hover:scale-105 shadow-lg"
          >
            ⬇ Descargar
          </button>
          <button
            onClick={imprimir}
            className="bg-white hover:bg-gray-100 text-[#1E3A5F] font-bold px-6 py-3 rounded-full transition-all hover:scale-105 shadow-lg"
          >
            🖨 Imprimir
          </button>
        </div>
      </div>
    </div>
  );
}

function Home() {
  const [secciones, setSecciones] = useState([]);
  const [destaques, setDestaques] = useState([]);
  const [todosDestaques, setTodosDestaques] = useState([]);
  const [destaquesConViajes, setDestaquesConViajes] = useState([]);
  const [paquetes, setPaquetes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroRegion, setFiltroRegion] = useState('');
  const [flyers, setFlyers] = useState([]);
  const [flyerAbierto, setFlyerAbierto] = useState(null);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const navProtected = (path) => isAuthenticated ? navigate(path) : navigate('/login');

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const seccionesResponse = await fetch(`${process.env.REACT_APP_API_URL}/secciones-home`);
        if (seccionesResponse.ok) {
          const seccionesData = await seccionesResponse.json();
          setSecciones(seccionesData);
        }

        let flyersData = [];
        try {
          const flyersResponse = await fetch(`${process.env.REACT_APP_API_URL}/flyers`);
          if (flyersResponse.ok) {
            flyersData = await flyersResponse.json();
            setFlyers(flyersData);
          }
        } catch (err) {
          console.warn('⚠️ Error cargando flyers:', err);
        }

        try {
          const destaquesResponse = await fetch(`${process.env.REACT_APP_API_URL}/destaques`);
          if (destaquesResponse.ok) {
            const destaquesData = await destaquesResponse.json();
            setTodosDestaques(destaquesData);
            const destaquesConFlyerOPaquete = [];
            const destaquesConPaquetesReales = [];
            for (const destaque of destaquesData) {
              const tieneFlyer = flyersData.some(f => f.destaque_id === destaque.id);
              let tienePaquetes = false;
              try {
                const pkgResponse = await fetch(`${process.env.REACT_APP_API_URL}/destaques/${destaque.id}/paquetes`);
                if (pkgResponse.ok) {
                  const paquetesDestaque = await pkgResponse.json();
                  tienePaquetes = !!(paquetesDestaque && paquetesDestaque.length > 0);
                }
              } catch (err) {
                console.warn(`Error verificando destaque ${destaque.id}:`, err);
              }
              // Una región entra al sidebar si tiene paquetes o flyers cargados
              if (tieneFlyer || tienePaquetes) destaquesConFlyerOPaquete.push(destaque);
              // "Temas" solo muestra destaques con viajes reales asociados
              if (tienePaquetes) destaquesConPaquetesReales.push(destaque);
            }
            setDestaques(destaquesConFlyerOPaquete);
            setDestaquesConViajes(destaquesConPaquetesReales);
          }
        } catch (error) {
          console.warn('⚠️ Error cargando destaques:', error);
        }

        const paquetesResponse = await fetch(`${process.env.REACT_APP_API_URL}/paquetes`);
        if (paquetesResponse.ok) {
          let paquetesData = await paquetesResponse.json();

          try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 15000);
            const externosResponse = await fetch(
              `${process.env.REACT_APP_API_URL}/paquetes-externos`,
              { signal: controller.signal }
            );
            clearTimeout(timeoutId);

            if (externosResponse.ok) {
              const externosData = await externosResponse.json();
              if (!externosData._fallback && externosData.estado === 1 && externosData.viajes) {
                paquetesData = paquetesData.map(pkg => {
                  const externo = externosData.viajes[String(pkg.id_externo)];
                  if (externo?.impuestos) {
                    return { ...pkg, impuestos: parseFloat(externo.impuestos) || 0 };
                  }
                  return pkg;
                });
              }
            }
          } catch (error) {
            console.warn('⚠️ Sin impuestos externos:', error.message);
          }

          setPaquetes(paquetesData);
        }
      } catch (error) {
        console.error('Error:', error);
        setError('Error al cargar los datos');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Rotación automática del filtro de región: resalta cada carpeta con flyers
  // y muestra sus imágenes; un click manual reinicia el ciclo desde ahí.
  // Se pausa mientras un flyer está abierto en el popup.
  useEffect(() => {
    if (flyers.length === 0 || flyerAbierto) return;
    const ciclo = ['', ...destaques
      .filter(d => flyers.some(f => f.destaque_id === d.id))
      .map(d => String(d.id))];
    if (ciclo.length < 2) return;

    const timer = setInterval(() => {
      setFiltroRegion(prev => {
        const i = ciclo.indexOf(prev);
        return ciclo[(i + 1) % ciclo.length];
      });
    }, ROTACION_FLYERS_MS);
    return () => clearInterval(timer);
  }, [flyers, destaques, flyerAbierto, filtroRegion]);

  const handleBuscarFiltros = () => {
    const params = new URLSearchParams();
    if (filtroTipo) params.set('categoria', filtroTipo);
    if (filtroRegion) params.set('destaque', filtroRegion);
    navProtected(`/paquetes${params.toString() ? '?' + params.toString() : ''}`);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1E3A5F]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-14 w-14 border-4 border-[#2AA8B0] border-t-transparent mx-auto mb-4"></div>
          <p className="text-white/70 font-medium">Cargando contenido...</p>
        </div>
      </div>
    );
  }

  const seccion1 = renderSection('seccion_1');
  const seccion2 = renderSection('seccion_2');
  const hayCarruseles = seccion1 || seccion2;

  // Flyers de la carpeta/región seleccionada ("" = Todas); si el admin todavía
  // no cargó ninguno, imágenes de ejemplo. Se reparten en filas de hasta 6.
  const hayFlyersCargados = flyers.length > 0;
  const flyersFiltrados = hayFlyersCargados
    ? (filtroRegion ? flyers.filter(f => String(f.destaque_id) === filtroRegion) : flyers)
        .map(f => ({ id: f.id, url: flyerUrl(f.archivo) }))
    : FLYERS_TEMPORALES;
  const filasFlyers = [];
  for (let i = 0; i < flyersFiltrados.length; i += 6) {
    filasFlyers.push(flyersFiltrados.slice(i, i + 6));
  }

  // El sidebar solo lista carpetas/regiones que tengan flyers cargados; una
  // carpeta vacía desaparece hasta que se le vuelvan a cargar imágenes
  const regionesSidebar = hayFlyersCargados
    ? destaques.filter(d => flyers.some(f => f.destaque_id === d.id))
    : destaques;

  return (
    <>
      <Helmet>
        <title>Opciones Argentinas | Inicio</title>
        <meta name="description" content="Tu agencia líder en salidas grupales." />
        <link rel="canonical" href={`${SITE_URL}/`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta property="og:title" content="Opciones Argentinas | Inicio" />
        <meta property="og:description" content="Tu agencia líder en salidas grupales." />
        <meta property="og:image" content={`${SITE_URL}/images/og-default.jpg`} />
        <meta property="og:site_name" content="Opciones Argentinas" />
        <meta property="og:locale" content="es_AR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Opciones Argentinas | Inicio" />
        <meta name="twitter:description" content="Tu agencia líder en salidas grupales." />
        <meta name="twitter:image" content={`${SITE_URL}/images/og-default.jpg`} />
      </Helmet>

      <Header />

      {/* Degradé hero → contenido */}
      <div className="h-16 bg-gradient-to-b from-black/50 to-white" />

      {/* ── SECCIÓN 1 desde CMS ── */}
      {seccion1 && (
        <section className="py-10 bg-white">
          <div className="container mx-auto px-4">
            <p className="text-[#2AA8B0] text-xs font-bold uppercase tracking-widest mb-1">Destacados</p>
            <h2 className="text-2xl md:text-3xl font-black text-[#1E3A5F] uppercase mb-6">
              {secciones[0]?.titulo || 'Lo Más Vendido'}
            </h2>
            {seccion1}
            <div className="text-right mt-3">
              <button onClick={() => navProtected('/paquetes')} className="text-sm text-[#2AA8B0] hover:underline font-medium">
                Ver más →
              </button>
            </div>
          </div>
        </section>
      )}

      {/* ── LOGOS DESTINOS (separador) ── */}
      <section className="py-8 bg-white border-t border-b border-gray-100">
        <h2 className="text-center text-sm font-bold text-gray-400 uppercase tracking-widest mb-6">
          Explorá el mundo con Opciones
        </h2>
        <div className="flex items-center justify-between w-full px-4 md:px-8">
          {DESTINOS_LOGOS.map((d) => {
            // Si ya existe un destaque con el mismo nombre lo usamos para filtrar
            // (aunque todavía no tenga viajes cargados); si no, cae al filtro por nombre de destino.
            const destaqueVinculado = todosDestaques.find(
              dest => dest.nombre.trim().toLowerCase() === d.nombre.trim().toLowerCase()
            );
            const destino = destaqueVinculado
              ? `/paquetes?destaque=${destaqueVinculado.id}`
              : `/paquetes?destinos=${encodeURIComponent(d.nombre)}`;
            return (
              <button
                key={d.nombre}
                onClick={() => navProtected(destino)}
                className="cursor-pointer hover:scale-105 hover:shadow-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#1E3A5F] rounded-full flex-1 flex justify-center"
                aria-label={`Ver paquetes a ${d.nombre}`}
              >
                <img
                  src={d.logo}
                  alt={`Opciones en ${d.nombre}`}
                  className="w-full max-w-[160px] md:max-w-[200px] h-auto object-contain"
                />
              </button>
            );
          })}
        </div>
      </section>

      {/* ── SECCIÓN 2 desde CMS ── */}
      {seccion2 && (
        <section className="py-10 bg-gray-50">
          <div className="container mx-auto px-4">
            <p className="text-[#2AA8B0] text-xs font-bold uppercase tracking-widest mb-1">Especiales</p>
            <h2 className="text-2xl md:text-3xl font-black text-[#1E3A5F] uppercase mb-6">
              {secciones[1]?.titulo || 'Paquetes Al Mejor Precio'}
            </h2>
            {seccion2}
            <div className="text-right mt-3">
              <button onClick={() => navProtected('/paquetes')} className="text-sm text-[#2AA8B0] hover:underline font-medium">
                Ver más →
              </button>
            </div>
          </div>
        </section>
      )}

      {/* Degradé → promociones */}
      <div className="h-16 bg-gradient-to-b from-gray-50 to-[#1E3A5F]/70" />

      {/* ── SECCIÓN AVISOS Y FLYERS DE LA SEMANA ── */}
      <section className="bg-[#1E3A5F] pb-12 md:pb-16">
        <div className="container mx-auto px-4">

          {/* Header de sección */}
          <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
            <div>
              <p className="text-[#2AA8B0] text-xs font-bold uppercase tracking-widest mb-2">
                Promociones
              </p>
              <h2 className="text-3xl md:text-5xl text-white uppercase leading-none">
                <span className="font-black">Avisos y Flyers</span>
                <span className="font-light"> de la Semana</span>
              </h2>
            </div>
            <button
              onClick={() => navProtected('/paquetes')}
              className="self-start sm:self-auto bg-red-500 hover:bg-red-600 text-white font-bold px-6 py-3 rounded-full transition-all hover:scale-105 flex-shrink-0 shadow-lg"
            >
              Ver todos →
            </button>
          </div>

          {/* Layout: sidebar + cards */}
          <div className="flex flex-col lg:flex-row gap-8">

            {/* Sidebar de filtros */}
            <aside className="lg:w-52 flex-shrink-0">
              <div className="space-y-6">

                <div>
                  <label className="block text-white/60 text-sm italic mb-2">
                    Mostrar por Tipo:
                  </label>
                  <select
                    value={filtroTipo}
                    onChange={(e) => setFiltroTipo(e.target.value)}
                    className="w-full bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-[#2AA8B0]"
                  >
                    <option value="" className="text-gray-800">Todos</option>
                    <option value="nacional" className="text-gray-800">Nacional</option>
                    <option value="internacional" className="text-gray-800">Internacional</option>
                  </select>
                </div>

                <div>
                  <label className="block text-white/60 text-sm italic mb-3">
                    Mostrar por Región:
                  </label>
                  <div>
                    <button
                      onClick={() => setFiltroRegion('')}
                      className={`w-full text-left py-2.5 border-b border-white/10 text-sm font-bold uppercase tracking-wide transition-colors ${filtroRegion === '' ? 'text-[#2AA8B0]' : 'text-white hover:text-[#2AA8B0]'}`}
                    >
                      Todas
                    </button>
                    {regionesSidebar.map((d) => (
                      <button
                        key={d.id}
                        onClick={() => setFiltroRegion(String(d.id))}
                        className={`w-full text-left py-2.5 border-b border-white/10 text-sm font-bold uppercase tracking-wide transition-colors ${filtroRegion === String(d.id) ? 'text-[#2AA8B0]' : 'text-white hover:text-[#2AA8B0]'}`}
                      >
                        {d.nombre}
                      </button>
                    ))}
                  </div>
                </div>

                <button
                  onClick={handleBuscarFiltros}
                  className="w-full bg-[#2AA8B0] text-white py-2.5 rounded-lg font-bold text-sm hover:bg-[#1E8A91] transition-colors"
                >
                  Buscar
                </button>
              </div>
            </aside>

            {/* Grid de cards */}
            <div className="flex-1 min-w-0">
              {/* TODO: restaurar carruseles de paquetes cuando las imágenes estén listas
              {hayCarruseles ? (
                <div className="space-y-10">
                  {seccion1 && (
                    <div>
                      <h3 className="text-white/50 text-xs font-bold uppercase tracking-widest mb-4">
                        {secciones.find(s => s.id === 1)?.titulo || 'Lo Más Vendido'}
                      </h3>
                      {seccion1}
                      <div className="text-right mt-3">
                        <button
                          onClick={() => navProtected('/paquetes')}
                          className="text-sm text-[#2AA8B0] hover:underline font-medium"
                        >
                          Ver más →
                        </button>
                      </div>
                    </div>
                  )}
                  {seccion2 && (
                    <div>
                      <h3 className="text-white/50 text-xs font-bold uppercase tracking-widest mb-4">
                        {secciones.find(s => s.id === 2)?.titulo || 'Paquetes Al Mejor Precio'}
                      </h3>
                      {seccion2}
                      <div className="text-right mt-3">
                        <button
                          onClick={() => navProtected('/paquetes')}
                          className="text-sm text-[#2AA8B0] hover:underline font-medium"
                        >
                          Ver más →
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex items-center justify-center h-48 text-white/30 text-sm">
                  No hay avisos disponibles por el momento.
                </div>
              )}
              */}

              {/* Flyers de la carpeta seleccionada (con imágenes de ejemplo como fallback) */}
              {filasFlyers.length === 0 ? (
                <div className="flex items-center justify-center h-48 text-white/40 text-sm">
                  No hay flyers para esta región por el momento.
                </div>
              ) : (
              <div className="space-y-10">
                {filasFlyers.map((items, idx) => (
                  <div key={`${filtroRegion}-${idx}`}>
                    <ScrollCarousel>
                      {items.map(f => (
                        <div
                          key={f.id}
                          data-card
                          className="flex-shrink-0 w-full sm:w-[calc(50%-8px)] lg:w-[calc(33.333%-11px)]"
                          style={{ scrollSnapAlign: 'start' }}
                        >
                          <button
                            onClick={() => setFlyerAbierto(f)}
                            className="block w-full cursor-pointer focus:outline-none focus:ring-2 focus:ring-[#2AA8B0] rounded-2xl"
                            aria-label="Ver flyer en grande"
                          >
                            <img
                              src={f.url}
                              alt="Flyer promocional"
                              className="w-full h-auto rounded-2xl shadow-lg hover:scale-105 transition-transform duration-300"
                            />
                          </button>
                        </div>
                      ))}
                    </ScrollCarousel>
                    <div className="text-right mt-3">
                      <button
                        onClick={() => navProtected('/paquetes')}
                        className="text-sm text-[#2AA8B0] hover:underline font-medium"
                      >
                        Ver más →
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Degradé oscuro → temas */}
      <div className="h-16 bg-gradient-to-b from-[#1E3A5F] to-white" />

      {/* ── SECCIÓN TEMAS ── */}
      {destaquesConViajes.length > 0 && (
        <section className="pb-12 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-center text-sm font-bold text-gray-400 uppercase tracking-widest mb-6">
              Temas
            </h2>
            <div className="flex flex-wrap justify-evenly gap-3 md:gap-4">
              {destaquesConViajes.map((destaque, idx) => {
                const iconos = [Globe, Plane, Tag, Sun, Calendar, Flag, Compass, Star, Umbrella, MapPin];
                const Icono = iconos[idx % iconos.length];
                return (
                  <button
                    key={destaque.id}
                    onClick={() => navProtected(`/paquetes?destaque=${destaque.id}`)}
                    className="flex flex-col items-center gap-2 p-3 md:p-4 rounded-2xl bg-white border border-gray-200 shadow-sm hover:shadow-md hover:-translate-y-0.5 hover:border-gray-400 transition-all cursor-pointer w-24 md:w-28"
                  >
                    <Icono size={32} strokeWidth={1.5} className="text-gray-700" />
                    <span className="text-xs md:text-sm font-semibold text-gray-700 text-center leading-tight">
                      {destaque.nombre}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {flyerAbierto && (
        <FlyerModal flyer={flyerAbierto} onClose={() => setFlyerAbierto(null)} />
      )}

      <Footer />
    </>
  );

  function renderSection(sectionId) {
    const sec = secciones.find(s => s.id === parseInt(sectionId.replace('seccion_', '')));
    if (!sec) return null;

    const paquetesSeccion = sec.paquetesIds
      ?.map(id => paquetes.find(p => p.id === id && p.estado === 'activo'))
      .filter(pkg => pkg);

    if (!paquetesSeccion || paquetesSeccion.length === 0) return null;

    return (
      <ScrollCarousel>
        {paquetesSeccion.map(pkg => (
          <div
            key={pkg.id}
            data-card
            className="flex-shrink-0 w-full sm:w-[calc(50%-8px)] lg:w-[calc(33.333%-11px)]"
            style={{ scrollSnapAlign: 'start' }}
          >
            <TravelCard
              paquete={pkg}
              onVerDetalles={(paquete) => {
                const params = new URLSearchParams();
                params.set('destino', paquete.destino);
                params.set('precio_max', paquete.tarifa || paquete.precio);
                navProtected(`/paquetes?${params.toString()}`);
              }}
            />
          </div>
        ))}
      </ScrollCarousel>
    );
  }
}

export default Home;
